"use client";

import clsx from "clsx";
import { atom, useAtom } from "jotai";
import { Focus } from "lucide-react";

export const inspectMode = atom(false);

export function Toolbar() {
  const [inspect, setInspect] = useAtom(inspectMode);

  return (
    <div className="fixed bottom-5 left-1/2 z-50 -translate-x-1/2 rounded-full border-2 border-gray-600 bg-gray-900/70 px-6 py-2 backdrop-blur">
      <button
        className={clsx(
          "flex h-6 w-6 items-center justify-center rounded text-white hover:bg-black/70",
          {
            "bg-gray-700 shadow-inner shadow-gray-800": inspect,
          }
        )}
        onClick={() => setInspect((v) => !v)}
      >
        <Focus size={16} />
      </button>
    </div>
  );
}
